<mat-card
        class="e-close-mix-large-card"
>
    <card-controller-panel
            [cardInfo]="cardControllerInfo"
    ></card-controller-panel>    
    <div class="e-close-mix-title-area">
        {{chartCardInfo.title}}
    </div>
    <div *ngIf="hasData && isDataReady">
        <div class="e-close-mix-legend-container">
            <div *ngFor="let legend of closingMixLegend" class="e-close-mix-legend-item-area">
                <div [ngStyle]="{ color: legend.color }" class="legend-icon">•</div>
                <div class="legend-title">{{ legend.name }}</div>             
            </div>
        </div>
        <div class="e-close-mix-chart-area row-layout-track">
            <div class="largecard-layout-box__50 donut-chart-area">
                <donut-chart
                        [action]="noDataType.action"
                        [title]="''"
                        [dataLabels]="false"
                        [data]="unitDonutChartData"
                        [uniqueId]="'eclose-donut-1'"
                        [legendText]="legendTextUnits"
                        [twoDonutsTogether]="true"
                        [loading]="!isDataReady"
                        [pointClickFunction]="drilldownFunction"
                >
                </donut-chart>
            </div>
            <div class="largecard-layout-box__50">
                <donut-chart
                        [action]="noDataType.action"
                        [title]="''"
                        [dataLabels]="false"
                        [data]="volumeDonutChartData"
                        [uniqueId]="'eclose-donut-2'"
                        [legendText]="legendTextVolume"
                        [twoDonutsTogether]="true"
                        [alternateValue]="true"
                        [loading]="!isDataReady"
                        [pointClickFunction]="drilldownFunction"
                >
                </donut-chart>
            </div> 
        </div>
    </div>
    <div *ngIf="!isDataReady" class="e-close-mix-spinner-area">
        <spin-loader [type]="'spinner'"></spin-loader>
    </div>
    <div class="e-close-mix-no-data-message-area" *ngIf="!hasData && isDataReady">
        <no-data-screen [noDataType]="noDataType"></no-data-screen>
    </div>
</mat-card>